import { createFeatureSelector, createSelector } from "@ngrx/store";
import { financeState } from "./finance.state";

export const getFinanceState = createFeatureSelector<financeState>('finance');

export const getFinance = createSelector(
    getFinanceState,
  (state) => state
);